/**
 * This file is a part of Amblique's projects.
 *
 * Copyright © Amblique - All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */

export default {
  baseStyle: (props) => ({
    container: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: 2,
    },
    card: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      padding: 3,
      backgroundColor: 'white',
      borderRadius: 'md',
      borderWidth: '1px',
      borderStyle: 'solid',
      borderColor: 'gray.200',
      transition: 'all 0.2s',
      minWidth: '120px',
      position: 'relative',
      _hover: {
        borderColor: 'gray.300',
      },
      _focus: {
        outline: 'none',
        boxShadow: 'outline',
      },
    },
    cardSelected: {
      borderColor: 'black',
      borderWidth: '2px',
      _hover: {
        borderColor: 'black',
      },
    },
    cardDisabled: {
      opacity: 0.6,
      cursor: 'not-allowed',
    },
    popularBadge: {
      position: 'absolute',
      top: 2,
      left: 2,
      backgroundColor: 'gray.700',
      color: 'white',
      fontSize: 'xs',
      fontWeight: 'semibold',
      padding: '2px 6px',
      borderRadius: 'sm',
      zIndex: 1,
    },
    thumbnail: {
      width: '60px',
      height: '60px',
      minWidth: '60px',
      minHeight: '60px',
      marginBottom: 2,
      borderRadius: 'sm',
      overflow: 'hidden',
      flexShrink: 0,
    },
    thumbnailImage: {
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'cover',
      width: '100%',
      height: '100%',
      border: '1px solid',
      borderColor: 'gray.300',
    },
    thumbnailFallback: {
      width: '100%',
      height: '100%',
      backgroundColor: 'gray.100',
      border: '1px solid',
      borderColor: 'gray.300',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    thumbnailFallbackText: {
      fontSize: 'xs',
      color: 'gray.500',
    },
    label: {
      fontSize: 'sm',
      fontWeight: 'normal',
      color: 'gray.900',
      textAlign: 'center',
      marginTop: 2,
    },
    link: {
      textDecoration: 'none',
      display: 'block',
    },
  }),
  parts: [
    'container',
    'card',
    'cardSelected',
    'cardDisabled',
    'popularBadge',
    'thumbnail',
    'thumbnailImage',
    'thumbnailFallback',
    'thumbnailFallbackText',
    'label',
    'link'
  ],
};
